import { environment } from "@/relay/environment";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { fetchQuery, graphql } from "react-relay";
import type { routeRankingEnabledQuery } from "./__generated__/routeRankingEnabledQuery.graphql";

export const Route = createFileRoute("/_visibility/_topnav/ranking")({
	component: RouteComponent,
	loader: async ({ context }) => {
		const { club } = context;

		const data = await fetchQuery<routeRankingEnabledQuery>(
			environment,
			graphql`
		    query routeRankingEnabledQuery($slug: String!) {
		      club(slug: $slug) {
				    configuration(key: "LEADERBOARD")
			    }
		    }
	`,
			{ slug: club.slug },
		).toPromise();

		if (
			data?.club.configuration?.length &&
			data?.club.configuration !== "ENABLED" &&
			data?.club.configuration !== "1"
		) {
			throw redirect({
				to: "/",
			});
		}
	},
});

function RouteComponent() {
	return <Outlet />;
}
